"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IeModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../../index");

var _link = require("../../../../link");

var _modal = require("../../../../modal");

var _ie = require("./ie.styled");

var _foreignTab = _interopRequireDefault(require("../../../../icons/foreign-tab"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IeModal = function IeModal(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/_react.default.createElement(_ie.IeModalStyled, {
    isOpen: true,
    onClose: onClose,
    measure: "lg"
  }, /*#__PURE__*/_react.default.createElement(_modal.Modal.Header, {
    hideClose: true,
    pt: 24
  }, /*#__PURE__*/_react.default.createElement(_index.Heading, {
    m: [0, -15, 17],
    as: "h4"
  }, "sorry for interrupting you, but...")), /*#__PURE__*/_react.default.createElement(_modal.Modal.Body, null, /*#__PURE__*/_react.default.createElement(_index.Row, {
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_index.Col, {
    col: 9
  }, /*#__PURE__*/_react.default.createElement(_index.Text, {
    measure: "sm",
    m: [0],
    style: {
      lineHeight: '22px'
    }
  }, "When using Internet Explorer, you may experience some visual issues when using our site. For the best experience, we recommend using a different browser (", /*#__PURE__*/_react.default.createElement(_link.A, {
    color: "primary",
    target: "_blank",
    href: "https://www.google.com/chrome/"
  }, "Chrome"), ",", ' ', /*#__PURE__*/_react.default.createElement(_link.A, {
    color: "primary",
    target: "_blank",
    href: "https://support.apple.com/downloads/safari"
  }, "Safari"), ' ', "or", ' ', /*#__PURE__*/_react.default.createElement(_link.A, {
    color: "primary",
    target: "_blank",
    href: "https://www.mozilla.org/en-US/firefox/new"
  }, "Firefox"), ".)", /*#__PURE__*/_react.default.createElement("br", null), "Or book with Zoey, our virtual assistant, by texting ", /*#__PURE__*/_react.default.createElement("b", null, "Hi"), " to ", /*#__PURE__*/_react.default.createElement("b", null, "38201"), ".")), /*#__PURE__*/_react.default.createElement(_index.Col, {
    col: 3
  }, /*#__PURE__*/_react.default.createElement(_index.Box, {
    align: "right"
  }, /*#__PURE__*/_react.default.createElement(_foreignTab.default, {
    color: "wine",
    measure: 64
  }))))), /*#__PURE__*/_react.default.createElement(_modal.Modal.Footer, {
    pb: 24,
    pt: 24
  }, /*#__PURE__*/_react.default.createElement(_index.Button, {
    as: "a",
    target: "_blank",
    href: "https://www.google.com/chrome/",
    fullWidth: true
  }, "use different browser")));
};

exports.IeModal = IeModal;
IeModal.displayName = 'IeModal';